var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order-duration"},[_c('div',{staticClass:"order-duration__start"},[_vm._v(" "+_vm._s(_vm.startTime)+" ")]),_c('div',{staticClass:"order-duration__divider"},[_vm._v(" / ")]),_c('div',{staticClass:"order-duration__end"},[_vm._v(" "+_vm._s(_vm.endTime)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }